import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        stack: {
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            alignSelf: 'strech',
            width: '100%',
            gap: ['medium.base', 'medium.sm', 'medium.md', 'small.lg'],
        },
        stackItem: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
        },
        textContainer: {
            display: 'flex',
            flexDir: 'row',
            gap: remCalc(2),
            color: 'text.default',
            textAlign: 'center',
            textStyle: 'body-small',
            fontWeight: 400,
            cursor: 'pointer',
            marginRight: remCalc(12),
        },
        stackText: {
            color: 'text.default',
        },
        filterHit: {
            color: 'text.secondary',
        },
    },
}
